import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useGlobale = create(
  persist(
    (set, get) => ({
      authenticated_bschool: false,
      user: null,
      
      // État du modal d'authentification
      authModal: {
        isOpen: false,
        message: '',
        onSuccess: null
      },

      updateUserInfo: (updatedUserData) => {
        set(state => ({
          ...state,
          user: {
            ...state.user,
            ...updatedUserData
          }
        }));
      },

      login: async (user, tokens) => {
        // Stocker les tokens dans localStorage
        localStorage.setItem('auth_tokens', JSON.stringify(tokens));
        
        // Mettre à jour l'état
        set({
          authenticated_bschool: true,
          user: user,
          // Fermer le modal si il était ouvert
          authModal: {
            isOpen: false,
            message: '',
            onSuccess: null
          }
        });
      },

      logout: () => {
        // Nettoyer les tokens
        localStorage.removeItem('auth_tokens');
        localStorage.removeItem('credentials');
        
        // Mettre à jour l'état
        set({
          authenticated_bschool: false,
          user: null,
          authModal: {
            isOpen: false,
            message: '',
            onSuccess: null
          }
        });
      },

      // Actions pour le modal d'authentification
      showAuthModal: (message = '', onSuccess = null) => {
        set(state => ({
          ...state,
          authModal: {
            isOpen: true,
            message,
            onSuccess
          }
        }));
      },

      hideAuthModal: () => {
        set(state => ({
          ...state,
          authModal: {
            isOpen: false,
            message: '',
            onSuccess: null
          }
        }));
      },

      // Nouvelle fonction pour forcer la déconnexion via le modal
      forceLogoutViaModal: () => {
        localStorage.removeItem('auth_tokens');
        localStorage.removeItem('credentials');
        set({
          authenticated_bschool: false,
          user: null,
          authModal: {
            isOpen: false,
            message: '',
            onSuccess: null
          }
        });
        // Rediriger vers la page de login
        window.location.href = '/login';
      },

      // Fonction pour vérifier si l'utilisateur est authentifié (en tenant compte du modal)
      isAuthenticated: () => {
        const state = get();
        // Si le modal est ouvert, considérer l'utilisateur comme toujours authentifié
        // pour éviter la redirection automatique
        if (state.authModal.isOpen) {
          return true;
        }
        return state.authenticated_bschool;
      },

      checkAuth: () => {
        const tokensString = localStorage.getItem('auth_tokens');
        if (tokensString) {
          try {
            const tokens = JSON.parse(tokensString);
            if (tokens.access && tokens.refresh) {
              // Vérifier si le token n'est pas expiré
              const base64Url = tokens.access.split('.')[1];
              const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
              const payload = JSON.parse(window.atob(base64));
              const currentTime = Date.now() / 1000;
              
              if (payload.exp > currentTime) {
                set({ authenticated_bschool: true });
                return true;
              } else {
                // Token expiré, mais ne pas mettre authenticated_bschool à false
                // car cela pourrait déclencher une redirection
                return false;
              }
            } else {
              set({ authenticated_bschool: false, user: null });
              return false;
            }
          } catch (error) {
            // Erreur de parsing, nettoyer
            localStorage.removeItem('auth_tokens');
            set({ authenticated_bschool: false, user: null });
            return false;
          }
        } else {
          set({ authenticated_bschool: false, user: null });
          return false;
        }
      },

      // Fonction pour forcer la déconnexion (utilisée par l'API pour les cas critiques)
      forceLogout: () => {
        localStorage.removeItem('auth_tokens');
        localStorage.removeItem('credentials');
        set({
          authenticated_bschool: false,
          user: null,
          authModal: {
            isOpen: false,
            message: '',
            onSuccess: null
          }
        });
      },
    }),
    {
      name: 'auth-storage',
      // Ne pas persister les tokens et le modal dans le store Zustand
      partialize: (state) => ({
        user: state.user,
        authenticated_bschool: state.authenticated_bschool
      })
    }
  )
);

export default useGlobale;